export async function loadAppServerConfig(pitchSide: boolean) {
  if (pitchSide) {
    // If pitch side, we don't load the app config from the ui server
    return {
      publicEnvVars: {}
    }
  }

  try {
    const response = await fetch('/config', { cache: 'no-store' })
    if (!response.ok) {
      throw new Error('app config not found')
    }
    const appServerConfig = await response.json()
    console.log('✅ loaded app config:', appServerConfig)
    return appServerConfig
  } catch (error) {
    console.error(
      '⚠️ Failed to load app config. Falling back to window.location parsing.',
      error
    )
    return {
      publicEnvVars: {}
    }
  }
}
